import { render, staticRenderFns } from "./assetPlan.vue?vue&type=template&id=b42c561a&scoped=true"
import script from "./assetPlan.vue?vue&type=script&lang=js"
export * from "./assetPlan.vue?vue&type=script&lang=js"
import style0 from "./assetPlan.vue?vue&type=style&index=0&id=b42c561a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c561a",
  null
  
)

export default component.exports